import React from 'react';

import { isServer } from '@tager/web-core';

import ErrorPage from '@/pages/_error';
import NotFoundPage from '@/pages/404';
import { CustomApp_PageContext } from '@/typings/hocs';
import { convertErrorToProps } from '@/utils/common';
import { getSharedThunkList } from '@/utils/thunks';

type Props =
  | {
      pageType: 'NOT_FOUND';
    }
  | {
      pageType: 'ERROR';
      error: Error;
    };

function DynamicPage(props: Props) {
  if (props.pageType === 'NOT_FOUND') {
    return <NotFoundPage />;
  }

  if (props.pageType === 'ERROR') {
    return <ErrorPage {...convertErrorToProps(props.error)} />;
  }

  return null;
}

DynamicPage.getInitialProps = async (
  context: CustomApp_PageContext
): Promise<Props> => {
  const { store, lang, res } = context;

  try {
    const requestsPromise = Promise.all([
      ...getSharedThunkList(store.dispatch, lang),
    ]);

    if (isServer()) {
      await requestsPromise;
    }

    if (res) {
      res.statusCode = 404;
    }

    return { pageType: 'NOT_FOUND' };
  } catch (error) {
    return { pageType: 'ERROR', error: error as Error };
  }
};

export default DynamicPage;
